import Switch from 'Components/common/Switch/Switch';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import Axios from 'Source/axiosPool';
import { EMAIL_SUFFIX } from 'Source/components/project/Config/Config';
import { showToast, validateEmail } from 'Source/globalFunction';
import useForm from 'Source/hooks/useForm';
import { checkIfAdmin } from 'Source/lib/authorization/authorization';
import { getPrefix, getSuggested } from 'Source/util/email';

import { getFields, saveCompanyForm } from './Config';
import Field from './Fields/Field/Field';
import DeactivateAccount from './Modal/DeactivateAccount/DeactivateAccount';

import DiscardChanges from '../Modal/DiscardChanges/DiscardChanges';
import StatusInfoButton from '@/src/components/common/Buttons/StatusInfoButton/StatusInfoButton';

@connect((store) => {
  return {
    project: store.project,
    loggedUser: store.loggedUser,
  };
})
class General extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      layout: 'view',
      validation: {},
      initFields: {},
      fields: {
        project: '',
        accountLead: {},
        accountEmail: '',
        groupEmail: '',
        color: '',
        picture: null,
      },
      initStatus: {},
      status: {
        emailNotification: false,
        appNotification: false,
      },
      error: false,
    };

    _.map(
      [
        'onChangeView',
        'onUpdateFields',
        'onUpdateAccountName',
        'onSubmit',
        'onUpdateStatus',
        'onActivation',
        'handleChange',
        'onDiscardChanges',
        'discardChanges',
        'onEdit',
      ],
      (fn) => {
        this[fn] = this[fn].bind(this);
      }
    );
  }
  componentDidUpdate(prev) {
    if (!_.isEqual(prev.isEdit, this.props.isEdit)) {
      if (this.props.isEdit === 'general') {
        this.onChangeView(null, 'form');
      } else {
        this.discardChanges();
      }
    } else if (!_.isEqual(prev.isOpen, this.props.isOpen)) {
      const { hasChanges } = this.props;
      if (
        prev.isOpen &&
        prev.isOpen === 'general' &&
        Object.keys(hasChanges).filter((f) => hasChanges[f]).length < 1
      ) {
        this.onChangeView(null, 'view');
      }
    }
  }
  onEdit(e) {
    const { project, hasChanges } = this.props;
    e.preventDefault();
    if (this.props.triggerEdit) {
      this.props.triggerEdit({ general: true });
    }
    if (Object.keys(hasChanges).filter((f) => hasChanges[f]).length > 0) {
      $('#accountSetting').modal('show');
    } else {
      this.onChangeView(e, 'form');
    }
  }
  onChangeView(e, view) {
    const { project, hasChanges } = this.props;
    const selected = project.Selected || {};
    if (e) {
      e.preventDefault();
    }

    if (view === 'form') {
      this.setState({
        ...this.state,
        initFields: {
          ...this.state.init,
          project: selected.project,
          accountEmail: selected.email,
          accountLead: {
            value: selected.lead.id,
            label: `${selected.lead.firstName} ${selected.lead.lastName}`,
          },
          color: selected.color,
          picture: selected.picture,
          groupEmail: selected.groupEmail,
        },
        fields: {
          ...this.state.fields,
          project: selected.project,
          accountEmail: selected.email,
          accountLead: {
            value: selected.lead.id,
            label: `${selected.lead.firstName} ${selected.lead.lastName}`,
          },
          color: selected.color,
          picture: selected.picture,
          groupEmail: selected.groupEmail,
        },
        initStatus: {
          ...this.state.status,
          emailNotification: Boolean(selected.emailNotification),
          appNotification: Boolean(selected.appNotification),
        },
        status: {
          ...this.state.status,
          emailNotification: Boolean(selected.emailNotification),
          appNotification: Boolean(selected.appNotification),
        },
        layout: view,
      });
    } else {
      this.setState({
        ...this.state,
        initFields: {
          project: '',
          accountEmail: '',
          accountLead: {},
          groupEmail: '',
          color: '',
          picture: null,
        },
        fields: {
          project: '',
          accountEmail: '',
          accountLead: {},
          groupEmail: '',
          color: '',
          picture: null,
        },
        initStatus: {
          emailNotification: false,
          appNotification: false,
        },
        status: {
          emailNotification: false,
          appNotification: false,
        },
        layout: view,
        error: false,
      });
    }
  }

  onUpdateFields(e) {
    this.setState({
      ...this.state,
      fields: {
        ...this.state.fields,
        [e.target.id]: e.target.value,
      },
      error: e.error,
    });
  }

  onUpdateAccountName(e) {
    const { setAccountName, setAccountNameTouched } = this.props;

    this.onUpdateFields(e);

    setAccountName(e.target.value);
    setAccountNameTouched(true);
  }

  onUpdateStatus(e) {
    this.setState(
      {
        ...this.state,
        status: {
          ...this.state.status,
          [e]: this.state.status[e] ? false : true,
        },
      },
      () => {
        if (!this.state.status.appNotification) {
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              emailNotification: false,
            },
          });
        }
      }
    );
  }

  onActivation() {
    const { project, dispatch } = this.props;
    const selected = project.Selected;

    if (selected.isActive) {
      $('#deactivateAccountModal').modal('show');
    } else {
      const status = {
        isActive: 1,
      };

      dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

      Axios.put(`api/project/status/${selected.id}`, status).then((response) => {
        if (response) {
          dispatch({ type: 'SET_PROJECT_SELECTED', Selected: { ...selected, isActive: 1 } });
          dispatch({ type: 'SET_PROJECT_NEWLY_ADDED', boolean: true });
          showToast('success', 'Account has been activated');
        }
        dispatch({ type: 'SET_PROJECT_REFETCH', boolean: true });
        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
      });
    }
  }

  async onSubmit() {
    const { project, dispatch, resetHookState, fieldEmail } = this.props;
    const selected = project.Selected;
    const data = {
      ..._.omit(selected, [
        'calendars_list',
        'company',
        'creator',
        'members',
        'projectManager',
        'project_holiday',
        'project_workdays',
        'team',
        'type',
      ]),
      groupEmail: this.state.fields.groupEmail,
      project: this.state.fields.project,
      projectManagerId: this.state.fields.accountLead.value,
      color: this.state.fields.color,
      email: fieldEmail.value,
    };

    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

    Axios.put(`api/project/${selected.id}`, data, { timeout: 10000 })
      .then(async (response) => {
        if (response) {
          const isFile = this.state.fields.picture instanceof File;
          let picture = this.state.fields.picture;

          if (isFile) {
            const formdata = new FormData();
            formdata.append('file', this.state.fields.picture);
            formdata.append('project_id', selected.id);

            const upload = await Axios.post(
              `api/project/upload?projectId=${selected.id}`,
              formdata
            );
            picture = upload.data;
          }

          const status = {
            emailNotification: this.state.status.emailNotification ? 1 : 0,
            appNotification: this.state.status.appNotification ? 1 : 0,
          };

          await Axios.put(`api/project/status/${selected.id}`, status).then((res_status) => {
            if (res_status) {
              const membersUrl = `/api/projects/${selected.id}/members`;
              Axios.get(membersUrl).then((res_members) => {
                if (res_members) {
                  dispatch({
                    type: 'SET_PROJECT_SELECTED',
                    Selected: {
                      ...selected,
                      groupEmail: response.data.project.groupEmail,
                      email: response.data.project.email,
                      project: response.data.project.project,
                      projectManager: response.data.project.projectManager,
                      leadId: response.data.project.leadId,
                      color: response.data.project.color,
                      appNotification: res_status.data.appNotification,
                      emailNotification: res_status.data.emailNotification,
                      picture: picture,
                      members: res_members.data, 
                    },
                  });

                  this.onChangeView(null, 'view');

                  showToast('success', 'Changes successfully saved!');
                }

                dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
                resetHookState();
              });
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        showToast('error', 'Something went wrong please try again later.');
        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
      });
  }

  handleChange(e) {
    const { project, dispatch } = this.props;
    const selected = project.Selected;
    let hasError = false;

    if (e.target.id === 'groupEmail' && e.target.value) {
      hasError = !validateEmail(e.target.value);
    }

    this.setState({
      ...this.state,
      fields: {
        ...this.state.fields,
        [e.target.id]: e.target.value === '' ? null : e.target.value,
      },
      ...(e.target.id === 'groupEmail' && hasError
        ? { validation: { groupEmail: hasError } }
        : { validation: {} }),
    });

    //dispatch({ type: "SET_PROJECT_SELECTED", Selected: {...selected, [e.target.id] : e.target.value}})
  }
  discardChanges() {
    const { triggerEdit, resetHookState } = this.props;

    this.onChangeView(null, 'view');
    if (triggerEdit) {
      triggerEdit({ general: false });
    }

    resetHookState();
    $('#generalDiscard').modal('hide');

    showToast('success', 'Changes have been discarded');
  }

  onDiscardChanges() {
    if (this.hasChanges()) {
      $('#generalDiscard').modal('show');
    } else {
      if (this.props.onCancel) {
        this.props.onCancel();
      }
      this.onChangeView(null, 'view');
    }
  }

  hasChanges = () => {
    const { fieldEmail } = this.props;

    return (
      !_.isEqual(this.state.initFields, this.state.fields) ||
      !_.isEqual(this.state.initStatus, this.state.status) ||
      this.state.fields.accountEmail != fieldEmail.value
    );
  };

  render() {
    const { project, loggedUser, fieldEmail, allowEdit } = this.props;
    const selected = project.Selected || {};
    const hasError =
      Object.keys(this.state.validation).length > 0 ||
      this.state.error ||
      !fieldEmail.props.valid ||
      !this.state.fields.project ||
      !this.state.fields.accountLead ||
      !this.state.fields.color;
    const hasChanges = fieldEmail.props.isValidated && this.hasChanges();
    const isAdmin = checkIfAdmin(loggedUser.data);
    const fields = getFields({
      selected,
      state: this.state,
      onUpdateFields: this.onUpdateFields,
      onUpdateAccountName: this.onUpdateAccountName,
      fieldEmailProps: fieldEmail.props,
      isAdmin,
    });
    const withPermission =
      loggedUser.data.id === selected.createdBy ||
      selected.leadId === loggedUser.data.id ||
      loggedUser.data.userRole < 3;

    if (this.props.editChange) {
      const changesProps = this.props.hasChanges;
      const changes = changesProps.general;
      if (changes !== (hasChanges && this.state.layout === 'form')) {
        this.props.editChange({ general: hasChanges && this.state.layout === 'form' });
      }
    }
    return (
      <div id="general" ref="general" className="memberFormsContainer mt0 pb0">
        <div className="memberFormContainer mt0 mb0">
          <div className="memberFormsHeader">
            <div className="formHeaderTitle">
              <h4>General</h4>
            </div>
            {this.state.layout === 'view' && selected.isActive && allowEdit && (
              <div className="formsHeaderActions">
                <div className="actionItem">
                  <a href="/" className="editProfile" onClick={(e) => this.onEdit(e)}>
                    <i className="material-icons">edit</i>
                    Edit
                  </a>
                </div>
              </div>
            )}
            {this.state.layout === 'form' && (
              <div className="formsHeaderActions">
                <div className="actionItem">
                  <button className="btnCancel" onClick={this.onDiscardChanges}>
                    Cancel
                  </button>
                </div>

                <div className="actionItem">
                  <button
                    className={`btnSave ${hasError || !hasChanges ? 'disabled' : ''}`}
                    onClick={this.onSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="memberFormBody">
            <form id="profile-form" className="pt20">
              <div
                className={`formSection ${this.state.layout === 'view' ? 'viewOnly' : 'onEdit'}`}
              >
                {this.state.layout === 'form' && (
                  <label className="requiredNote">
                    (<sup>*</sup>) Indicates a required field
                  </label>
                )}
                {fields.map((f) => (
                  <Field
                    key={`field_${f.id}`}
                    view={this.state.layout}
                    field={{
                      ...f,
                      onChange: this.handleChange,
                    }}
                    validation={this.state.validation}
                  />
                ))}
              </div>
              <div className="formSection notificationSection">
                <div className="formSectionTitle">
                  <span>Notifications</span>
                </div>
                <div className="formContainer">
                  <label>In-App</label>
                  {this.state.layout === 'form' && (
                    <Switch
                      isActive={this.state.status.appNotification}
                      onChange={() => this.onUpdateStatus('appNotification')}
                    />
                  )}
                  {this.state.layout === 'form' && (
                    <span>{this.state.status.appNotification ? 'Enabled' : 'Disabled'}</span>
                  )}
                  {this.state.layout === 'view' && (
                    <span>{selected.appNotification ? 'Enabled' : 'Disabled'}</span>
                  )}
                </div>
                <div className="formContainer">
                  <label>Email</label>
                  {this.state.layout === 'form' && (
                    <Switch
                      isActive={this.state.status.emailNotification}
                      onChange={() => this.onUpdateStatus('emailNotification')}
                      disabled={!this.state.status.appNotification}
                    />
                  )}
                  {this.state.layout === 'form' && (
                    <span>{this.state.status.emailNotification ? 'Enabled' : 'Disabled'}</span>
                  )}
                  {this.state.layout === 'view' && (
                    <span>{selected.emailNotification ? 'Enabled' : 'Disabled'}</span>
                  )}
                </div>
              </div>
              <div className="formSection accountStatusSection">
                <div className="formContainer">
                  <div className="formContainerInfo">
                    <label>Account Status</label>
                    <span className='tw-inline-flex tw-items-center'>
                      {selected.isActive ? 'Active' : 'Inactive'}
                      {!selected.isActive && <StatusInfoButton tooltipPosition='right' />}
                    </span>
                  </div>
                  {withPermission && (
                    <Switch isActive={selected.isActive} onChange={() => this.onActivation()} />
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>

        <DeactivateAccount />
        <DiscardChanges onCancel={this.discardChanges} id={'generalDiscard'} />
      </div>
    );
  }
}

const withHooks = (Component) => (props) => {
  const email = props.selected && props.selected.email;
  const projectId = useSelector((store) => store.project.Selected.id);
  const { registerFormInput, resetForm, setDefaultValues, setFormFieldValue } = useForm({
    validationRules: saveCompanyForm.email.validationRules(projectId),
  });
  const [accountName, setAccountName] = useState('');
  const [accontNameTouched, setAccountNameTouched] = useState(false);
  const fieldEmailProps = registerFormInput('email');
  const fieldEmail = {
    props: fieldEmailProps,
    value: `${fieldEmailProps.value}@${EMAIL_SUFFIX}`,
  };

  useEffect(() => {
    if (!accontNameTouched) {
      return;
    }

    // Remove auto suggest in edit mode
    // const suggestedEmail = getSuggested(accountName)
    // setFormFieldValue('email', suggestedEmail);

    // if (accountName) {
    //     fieldEmailProps.onValidate({
    //         target: {
    //             name: 'email',
    //             value: suggestedEmail
    //         }
    //     })
    // }
  }, [accountName, accontNameTouched]);

  useEffect(() => {
    if (!email) {
      return;
    }

    const formattedEmail = getPrefix(email);

    setDefaultValues({
      email: formattedEmail,
    });
  }, [email]);

  const resetHookState = useCallback(() => {
    setAccountName('');
    setAccountNameTouched(false);
    resetForm();
  }, [fieldEmail]);

  return (
    <React.Fragment>
      <Component
        {...props}
        fieldEmail={fieldEmail}
        setAccountName={setAccountName}
        setAccountNameTouched={setAccountNameTouched}
        resetHookState={resetHookState}
      />
    </React.Fragment>
  );
};

export default withHooks(General);
